// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1RUYI","form":"styles_form__1c9jH"};